/**
 * @generated SignedSource<<135d8cf0c744cbd96a25b95a9e82c0a6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraLongRunningTaskStatus = "CANCELLED" | "CANCEL_REQUESTED" | "COMPLETE" | "DEAD" | "ENQUEUED" | "FAILED" | "RUNNING" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ProcessResponse$data = {
  readonly failedAccessibleIssues: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly issue: {
          readonly issueId: string;
          readonly key: string;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly progress: AGG$Long | null | undefined;
  readonly status: JiraLongRunningTaskStatus | null | undefined;
  readonly totalIssueCount: number | null | undefined;
  readonly " $fragmentType": "ProcessResponse";
};
export type ProcessResponse$key = {
  readonly " $data"?: ProcessResponse$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProcessResponse">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ProcessResponse",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "progress"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "kind": "ScalarField",
      "name": "totalIssueCount"
    },
    {
      "concreteType": "JiraIssueBulkOperationFailureConnection",
      "kind": "LinkedField",
      "name": "failedAccessibleIssues",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraIssueBulkOperationFailureEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraIssueBulkOperationFailure",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssue",
                  "kind": "LinkedField",
                  "name": "issue",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "issueId"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "key"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssueBulkOperationProgress"
};

(node as any).hash = "c9a32d501081831ea216bde4dcb8c26d";

export default node;
